export enum PdfKey {
    ASK_FOR_CHILD_PDF = 'ASK_FOR_CHILD_PDF',
}
